export class StatisticsData {
    constructor(
        readonly xAxis: string,
        readonly yAxis: number,
        readonly isValid: boolean,
        readonly tooltipDate: string
    ) { }
}

export class StatisticsResult {
    constructor(
        readonly statisticsData: StatisticsData[],
        readonly timeUnit: string
    ) { }
}
export class StatisticsFilters {
    constructor(
        readonly dgeId: number,
        readonly numberHours: number,
        readonly customNumberHoursFrom: string,
        readonly customNumberHoursTo: string,
        readonly lastJobId: number
    ) { }
}

export class StatisticsSearch {
    // eslint-disable-next-line max-params
    constructor(
        readonly key: SearchKeyType,
        readonly dgeId: number,
        readonly numberHours: number,
        readonly customNumberHoursFrom: string,
        readonly customNumberHoursTo: string,
        readonly lastJobId: number
    ) { }
}

export enum SearchKeyType {
    GeneratedDocuments = 'generated-documents',
    GeneratedTransactions = 'generated-transactions',
    AverageWaitTime = 'average-wait-time'
}

export class StatisticsCardSearch {
    constructor(
        readonly dgeId: number,
        readonly numberHours: number,
        readonly customNumberHoursFrom: string,
        readonly customNumberHoursTo: string,
        readonly lastJobId: number
    ) { }
}

export class StatisticsCardResult {
    constructor(
        readonly generatedDocuments: number,
        readonly generatedTransactions: number,
        readonly generatedPages: number,
        readonly executedJobs: number,
        readonly errors: number
    ) { }
}